module.exports = __webpack_public_path__ + "img/gl.dfbc72c0.svg";